import {Button, ButtonGroup, Card, CloseButton, Col, Image, Row} from "react-bootstrap";
import * as Input from '../../inputs';
import VerticalInputElementForm from "../VerticalInputElementForm/VerticalInputElementForm";
import {SimpleNumberSelectOption} from "../../types";

export enum LogoVisibilityTypes {
    SYSTEM = 1,
    LLP = 2,
    SYSTEM_AND_LLP = 3
}

export interface HeaderLogoElementForm extends Record<string, Input.InputField> {
    is_image: Input.CheckboxField;
    src: Input.TextField;
    alt: Input.TextField;
    target: Input.TextField;
    visibility: Input.SingleSelectField<SimpleNumberSelectOption>;
}

type Props = {
    form: HeaderLogoElementForm;
    on_form_change: (key: string, value: any) => void;
    on_remove: () => void;
};

const HeaderLogoElementCard = ({
                                   form,
                                   on_form_change,
                                   on_remove
                               }: Props) => {
    const render_image_preview = () => {
        if (!form.is_image.value) return null;
        return (
            <Image src={form.src.value} alt={form.alt.value} fluid/>
        );
    };
    return (
        <Card className={'h-100'}>
            <Card.Body>
                <CloseButton onClick={() => on_remove()} className={'position-absolute end-0 top-0 mt-2 me-2'}/>
                <Row className={'mb-2'}>
                    <Col>
                        <ButtonGroup>
                            <Button
                                type={'button'}
                                variant={'outline-secondary'}
                                active={form.is_image.value}
                                onClick={() => on_form_change('is_image', true)}
                            >Image</Button>
                            <Button
                                type={'button'}
                                variant={'outline-secondary'}
                                active={!form.is_image.value}
                                onClick={() => on_form_change('is_image', false)}
                            >Text</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <VerticalInputElementForm
                    fields={form}
                    changed={on_form_change}
                    group_className={'mb-2'}
                    included_keys={['src', 'alt', 'target', 'visibility']}
                />
                {render_image_preview()}
            </Card.Body>
        </Card>
    )
};

export default HeaderLogoElementCard;
